// extracted by mini-css-extract-plugin
export default {"container":"MJBz","title":"uiIg","description":"kghl"};